export enum ClientState {
    Foreground = 1,
    Background = 2,
    Closed = 3,
}
